var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { Colors } from '../colors';
import { PrimeIcon } from '../../icons';
import { defaultButtonRootClasses, defaultCenterClasses, defaultItemClasses, defaultLeftClasses, defaultRightClasses, IconSize } from './button.config';
import { CircularProgress } from '@mui/material';
import { Link } from 'react-router-dom';
var linkAlignStyles = {
    center: {
        display: 'table-cell',
        verticalAlign: "middle",
    },
    "flex-start": {
        display: 'table-cell',
        verticalAlign: "top",
    },
    "flex-end": {
        display: 'table-cell',
        verticalAlign: "bottom",
    },
    "none": { display: 'table-cell' },
};
var linkJustifyStyles = {
    center: {
        display: 'table-cell',
        textAlign: 'center',
    },
    "flex-start": {
        display: 'table-cell',
        textAlign: 'start',
    },
    "flex-end": {
        display: 'table-cell',
        textAlign: 'end',
    },
    "stretch": { display: 'table-cell' },
    "none": { display: 'table-cell' },
};
var expandedLinkStyle = function (props) { return ({
    justifyContent: props.justify || 'center'
}); };
var expandedLinkItemStyle = function (props) { return (__assign(__assign(__assign({}, linkAlignStyles[props.align || 'center']), linkJustifyStyles[props.justify || 'center']), { width: "100%" })); };
var RenderItem = function (_a) {
    var content = _a.content, _b = _a.orientation, orientation = _b === void 0 ? 'none' : _b;
    if (Array.isArray(content)) {
        return _jsx(_Fragment, { children: content.map(function (item, key) { return _jsx(RenderItem, { content: item, orientation: orientation }, key); }) });
    }
    else if (content)
        return _jsx("div", __assign({ className: classNames(defaultItemClasses, "__content_item_".concat(orientation)) }, { children: content }));
    return null;
};
function getIcon(icon) {
    if (typeof icon === 'function')
        return icon;
    else if (typeof icon === 'object')
        return function () { return _jsx(_Fragment, { children: icon }); };
    else if (typeof icon === 'string')
        return function () { return _jsx(PrimeIcon, { icon: icon }); };
}
export var LeftContent = function (_a) {
    var size = _a.size, icon = _a.icon, iconLeft = _a.iconLeft, textColor = _a.textColor, textColorCss = _a.textColorCss, _b = _a.contentLeft, contentLeft = _b === void 0 ? null : _b, loading = _a.loading;
    if (loading)
        return null;
    var iconNode = null;
    if (icon) {
        var Icon = getIcon(icon);
        var props = {
            size: IconSize[size],
            color: textColorCss || Colors[textColor]
        };
        iconNode = (_jsx(RenderItem, { content: _jsx(Icon, __assign({}, props)) }));
    }
    var iconLeftNode = null;
    if (iconLeft) {
        var Icon = getIcon(iconLeft);
        var props = {
            size: IconSize[size],
            color: textColorCss || Colors[textColor]
        };
        iconLeftNode = (_jsx(RenderItem, { orientation: "left", content: _jsx(Icon, __assign({}, props)) }));
    }
    if (iconNode || iconLeftNode || contentLeft)
        return (_jsxs("div", __assign({ className: defaultLeftClasses }, { children: [iconNode, iconLeftNode, _jsx(RenderItem, { orientation: "left", content: contentLeft })] })));
    return null;
};
export var LoadingContent = function (_a) {
    var loading = _a.loading, size = _a.size;
    if (loading)
        return (_jsx("div", __assign({ className: defaultCenterClasses }, { children: _jsx(RenderItem, { content: _jsx(CircularProgress, { color: "inherit", size: IconSize[size] || 18, thickness: 5 }) }) })));
    return null;
};
export var CenterContent = function (_a) {
    var loading = _a.loading, label = _a.label, _b = _a.contentCenter, contentCenter = _b === void 0 ? null : _b;
    if (loading)
        return null;
    if (label || contentCenter)
        return (_jsxs("div", __assign({ className: defaultCenterClasses }, { children: [_jsx(RenderItem, { content: label }), _jsx(RenderItem, { content: contentCenter })] })));
    return null;
};
export var RightContent = function (_a) {
    var size = _a.size, textColorCss = _a.textColorCss, textColor = _a.textColor, iconRight = _a.iconRight, _b = _a.contentRight, contentRight = _b === void 0 ? null : _b, loading = _a.loading;
    if (loading)
        return null;
    var iconRightNode = null;
    if (iconRight) {
        var Icon = getIcon(iconRight);
        var props = {
            size: IconSize[size],
            color: textColorCss || Colors[textColor]
        };
        iconRightNode = (_jsx(RenderItem, { orientation: "right", content: _jsx(Icon, __assign({}, props)) }));
    }
    if (iconRightNode || contentRight)
        return (_jsxs("div", __assign({ className: defaultRightClasses }, { children: [iconRightNode, _jsx(RenderItem, { orientation: "right", content: contentRight })] })));
    return null;
};
export function getButtonContent(children, props) {
    var _a;
    var rootClasses = classNames(defaultButtonRootClasses, (_a = {},
        _a["__align-".concat(props.align || 'center')] = true,
        _a["__justify-".concat(props.justify || 'center')] = true,
        _a));
    if (props.loading) {
        return (_jsx("div", __assign({ className: rootClasses }, { children: _jsx(LoadingContent, __assign({}, props)) })));
    }
    var content = (_jsxs("div", __assign({ className: rootClasses }, { children: [typeof children === 'object' && children, typeof children !== 'object' && _jsxs(_Fragment, { children: [_jsx(LeftContent, __assign({}, props)), _jsx(CenterContent, __assign({}, props, { label: props.children || props.label })), _jsx(RightContent, __assign({}, props))] })] })));
    if (props.reactLink || props.legacyLink) {
        if (props.disabled)
            content = _jsx("a", __assign({ className: "__a", style: expandedLinkStyle(props) }, { children: _jsx("div", __assign({ style: expandedLinkItemStyle(props) }, { children: content })) }));
        else if (props.reactLink)
            content = _jsx(Link, __assign({ className: "__a", style: expandedLinkStyle(props), to: props.reactLink }, { children: _jsx("div", __assign({ style: expandedLinkItemStyle(props) }, { children: content })) }));
        else if (props.legacyLink)
            content = _jsx("a", __assign({ className: "__a", style: expandedLinkStyle(props), href: props.legacyLink }, { children: _jsx("div", __assign({ style: expandedLinkItemStyle(props) }, { children: content })) }));
    }
    return content;
}
;
